import _ from 'lodash-es';

export default (variant_image_map, scope = 'combo') => {
  let variants_found = false;
  let duplicates = false;

  _.every(variant_image_map, (variants) => {
    let first;
    
    _.every(variants, (variant) => {
      const comparison = (scope === 'combo') ? variant.combo : variant.option1;

      if (!first) {
        first = comparison;
        variants_found = true;
      }

      // An image shouldn't be assigned to multiple combos/option1s, that means the image isn't unique
      if (first !== comparison) {
        duplicates = true;
        return false;
      }
      
      return true;
    });

    if (duplicates) {
      return false;
    }

    return true;
  });

  if (!variants_found) {
    duplicates = true;
  }

  return duplicates;
};